import { BaseHelper } from 'services/BaseGraphQLAPIHelper';

import { getListInFilterValue } from 'utils';

export const getAdminAlertList = (
  afterCursor,
  search,
  statusIn,
  creationDateGte,
  creationDateLte,
  creationDateTimeGt,
  creationDateTimeLt,
  orderBy = '-creationDate',
) => {
  let searchString = '';
  searchString += `first: 20`;
  searchString += `, orderBy: "${orderBy}"`;
  if (afterCursor) {
    searchString += `,after: "${afterCursor}"`;
  }
  if (search) {
    searchString += `,searchBy: "${search}"`;
  }
  if (statusIn) {
    searchString += `,statusIn: "${getListInFilterValue(statusIn)}"`;
  }
  if (creationDateGte) {
    searchString += `,creationDateGte: "${creationDateGte}"`;
  }
  if (creationDateLte) {
    searchString += `,creationDateLte: "${creationDateLte}"`;
  }
  if (creationDateTimeGt) {
    searchString += `,creationDateTimeGt: "${creationDateTimeGt}"`;
  }
  if (creationDateTimeLt) {
    searchString += `,creationDateTimeLt: "${creationDateTimeLt}"`;
  }

  const query = `query AdminAlerts {
    adminAlerts(
      ${searchString},
    ) {
      totalToDo
      newestAlertTime
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          pk
          id
          alertType
          description
          isRead
          status
          creationDate
          reclaimedRewards
          transaction {
            id
            pk
          }
          originalTransaction {
            id
            pk
          }
          customer {
            id
            pk
            membershipId
            isReset
            isTransferred
          }
        }
      }
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const getNewestAlertTime = () => {
  const query = `query NewestAdminAlert {
    adminAlerts(
      first: 1,
    ) {
      totalToDo
      newestAlertTime
    }
  }`;
  const variables = {};
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateAdminAlert = (inputBody) => {
  const query = `
  mutation UpdateAdminAlert($input: UpdateAdminAlertInput!) {
    updateAdminAlert(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};

export const updateAllAdminAlerts = (inputBody) => {
  const query = `
  mutation UpdateAdminAlerts($input: UpdateAdminAlertsInput!) {
    updateAdminAlerts(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }`;
  const variables = {
    input: inputBody,
  };
  return BaseHelper.callGraphQLAPI({ query, variables });
};
